// Configuración comercial de la landing. Editar acá — no se muestra en la página.
export const offer = {
  checkoutUrl: 'https://latam-saberes-ancestrales.impultienda.ar/checkout/compra',
  productName: 'Megapack Saberes Ancestrales',
  price: 'US$15',
  originalPrice: 'US$65',
  priceValue: 15,
  currency: 'USD',
  // Fecha y hora REAL de cierre (ISO 8601 con zona horaria), por ejemplo
  // '2026-10-20T23:59:00-03:00'. Si se deja en null, se usa el contador
  // automático de `evergreenHours`.
  closesAt: null as string | null,
  // Contador automático: horas desde la primera visita de cada persona.
  // Se guarda en su navegador, así que NO se reinicia al actualizar la página.
  // Poner null para ocultar el contador cuando no hay fecha real.
  evergreenHours: 23 as number | null,
  // Cupos disponibles al precio promocional. Con null, queda oculto.
  spotsAvailable: 6 as number | null,
  // Muestra la sección de testimonios.
  testimonialsVerified: true,
}
